module.exports = __webpack_public_path__ + "img/external_link.ac05cd4f.svg";